import {
  ComponentSchollTermDatesInput,
  UpdateSchollTermDatesMutation,
  UpdateSchollTermDatesMutationVariables,
  AdminOnboarding,
  AdminOnboardingQuery,
  AdminOnboardingQueryVariables,
} from './../../graphql/generated/graphql';
import axios from 'axios';
import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { QUERY_ADMIN_ONBOARDING } from '@/graphql/queries/on-boarding/admin';
import { getAuthentication } from '@/hooks/useAuthentication';
import { UPDATE_SCHOOL_TERM_DATES } from '@/graphql/mutations/on-boarding/school';
import { RowData } from '@/pages/admin/components/spreadsheet';

export const getPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<AdminOnboardingQuery, AdminOnboardingQueryVariables>({
      query: QUERY_ADMIN_ONBOARDING,
    }),
  );

  return {
    page: data?.adminOnboarding?.data?.attributes as AdminOnboarding,
    error,
  };
};

export const updateSchoolTermDates = async (schoolId: string, termDates: ComponentSchollTermDatesInput) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.mutate<UpdateSchollTermDatesMutation, UpdateSchollTermDatesMutationVariables>({
      mutation: UPDATE_SCHOOL_TERM_DATES,
      variables: {
        id: schoolId,
        input: {
          termDates: termDates,
        },
      },
    }),
  );

  return {
    data,
    error,
  };
};

export async function inviteStaff(schoolId: number, preview?: boolean) {
  let data, error;

  try {
    const { data: response } = await axios({
      method: 'post',
      url: `${import.meta.env.VITE_API_URL}/api/school/invite-staff`,
      data: { schoolId, preview },
    });

    data = response;
  } catch (err) {
    console.error(err);
    // eslint-disable-next-line import/no-named-as-default-member
    if (axios.isAxiosError(err) && err.response) {
      error = err.response?.data?.error;
    }
  }

  return { data, error };
}

export async function importStaff(schoolId: number, users?: RowData[]) {
  let data, error;

  try {
    const { data: response } = await axios({
      method: 'post',
      url: `${import.meta.env.VITE_API_URL}/api/school/import-staff`,
      data: { schoolId, users },
    });

    data = response;
  } catch (err) {
    console.error(err);
    // eslint-disable-next-line import/no-named-as-default-member
    if (axios.isAxiosError(err) && err.response) {
      error = err.response?.data?.error;
    }
  }

  return { data, error };
}

export async function downloadPDF(code: string, name: string) {
  let data, error;

  try {
    const context = getAuthentication();

    const { data: response } = await axios({
      method: 'get',
      url: `${import.meta.env.VITE_API_URL}/api/generate-pdf-invitation?uniqueCode=${code}&schoolName=${name}`,
      headers: {
        Authorization: `Bearer ${context.accessToken}`,
      },
    });

    data = response;
  } catch (err) {
    console.error(err);
    // eslint-disable-next-line import/no-named-as-default-member
    if (axios.isAxiosError(err) && err.response) {
      error = err.response?.data?.error;
    }
  }

  return { data, error };
}

export async function getListStaff(page: number, pageSize: number, search?: string, status?: string) {
  let data, error;

  try {
    const params: { page: number; pageSize: number; search?: string; status?: string } = { page, pageSize };
    if (search) params.search = search;
    if (status && status !== 'all') params.status = status;

    const { data: response } = await axios({
      method: 'get',
      url: `${import.meta.env.VITE_API_URL}/api/school/list-staff`,
      params,
      headers: { Authorization: `Bearer ${getAuthentication()?.accessToken}` },
    });

    data = response;
  } catch (err) {
    console.error(err);
    // eslint-disable-next-line import/no-named-as-default-member
    if (axios.isAxiosError(err) && err.response) {
      error = err.response?.data?.error;
    }
  }

  return { data, error };
}
